<template>
  <div class="main">
    <div class="nav">
      <van-nav-bar
        title="就诊人列表"
        right-text="添加"
        left-arrow
         left-text="返回"
        @click-left="onClickLeft"
        @click-right="onClickRight"
      />
    </div>
    <div class="empty" v-if="cardList.length === 0">
      <van-empty image="https://account.kmmds.top/datainfo_pic/error.png"  description="暂无就诊卡信息" />
     <div class="emptyBtn">
        <van-button
        color="#5B8DF6"
        plain
        size="large"
        class="emptyBtn_text"
        round
        @click="onClickRight"
        >立即绑卡</van-button
      >
     </div>
    </div>
    <div class="cell">
      <div
        class="item"
        size="large"
        v-for="(item, index) in cardList"
        :key="index"
      >
        <div class="cell_item">
          <div class="title">{{ item.clientName }}</div>
          <div class="value">{{ item.medCardNo }}</div>
        </div>
        <div class="cell_item">
          <div class="value">tel: {{ item.phoneNumber }}</div>
          <!-- class="btn_mini_style" -->
          <div>
            <van-button
              color="#5B8DF6"
              size="small"
              class="btn_mini_style"
              round
              @click="Dialog(item.clientName, item.medCardNo)"
              >选择</van-button
            >
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Nav from "../../components/nav";
export default {
  data() {
    return {
      cardList: "",
      path: "",
      ispath: "",
     healthCardflag:null,
    };
  },
  components: {
    Nav,
  },
  beforeRouteEnter(to, from, next) {
    // console.log(from.path);

    next((vm) => {
      // this.path= from.path
      vm.path = from.path;
      // console.log(vm.path);
    });
  },
  mounted() {
    this.getclientId();
    if (this.$route.query.ispath) {
      this.ispath = this.$route.query.ispath;
    }
  },
  methods: {
    //获取
    async getclientId() {
      try {
        this.$showLoad();
        // this.isLoad = true
        let url = "/medicalcard/getclientcardlist";
        let data = null;
        await this.$axios_request.axios_request_body(
          "nodeserver",
          url,
          "POST",
          null,
          (data) => {
            this.cardList = data.data;
            this.gethealthCardflag ();
            this.$hideLoad();
          }
        );
      } catch (error) {
        console.log(error);
        this.$hideLoad();
      }
    },
    async gethealthCardflag() {
      try {
        this.$showLoad();
        // this.isLoad = true
        let url = "/healthcardcontroller/gethealthCardflag";
        await this.$axios_request.axios_request_body(
          "nodeserver",
          url,
          "POST",
          null,
          (data) => {
            this.healthCardflag=data.data
           
            console.log()
          }
        );
      } catch (error) {
        console.log(error);
        this.$hideLoad();
      }
    },
    onClickLeft() {
      this.$router.go(-1);
    },
    //跳转新建绑卡页
    onClickRight() {
      this.$router.push({
        path: this.healthCardflag?"/HealthcardList":"/patient_card_bind_C",
        query: {
          ispath: this.$route.query.ispath,
        },
      });
    },
    //确认事件
    Dialog(name, clientId) {
      this.$dialog
        .confirm({
          message: "确认选择用户:" + name,
        })
        .then(() => {
          if (
            this.path == "/patient_card_list_C" ||
            this.path == "/patient_card_create_C" ||
            this.path == "/patient_card_bind_C"
          ) {
            if (this.ispath == 1) {
              this.$router.push({
                path: "/ghdetail",
                query: {
                  name,
                  clientId,
                },
              });
              return;
            } else if (this.ispath == 2) {
              this.$router.push({
                path: "/no_details",
                query: {
                  name,
                  clientId,
                },
              });
              return;
            }
          }
          // on confirm
          //把名字传回上一页面
          this.$router.push({
            path: this.path,
            query: {
              name,
              clientId,
            },
          });
          return;
        })
        .catch(() => {
          // on cancel
        });
    },
  },
};
</script>

<style lang="scss">
.van-nav-bar .van-icon {
  color: white;
}
.van-nav-bar__title {
  color: white;
}
.van-nav-bar__text {
  color: white;
}
.van-nav-bar {
  background-color: #5b8df6;
}
.nav {
  letter-spacing: 5px;
}
.van-nav-bar__left,
.van-nav-bar__right {
  font-size: 25px;
}
.main {
  width: 100%;
  height: 100vh;
  .cell {
    display: flex;
    flex-direction: column;
    width: 93%;
    margin: 0px auto;
    .item {
      display: flex;
      flex-direction: column;
      padding-top: 16px;
      padding-bottom: 16px;
      &::after {
        border-bottom: 0;
      }
      margin-bottom: 15px;
      background-color: #f7f8fa;
      box-shadow: 0 8px 12px #ebedf0;
      border-radius: 8px;
      .cell_item {
        width: 93%;
        line-height: 40px;
        margin-left: 10px;
        margin-right: 10px;
        display: flex;
        justify-content: space-between;
        .title {
          font-size: 18px;
          color: #323233;
        }
        .value {
          font-size: 16px;
          color: #555;
        }
        .label {
          font-size: 15px;
          color: #999;
        }
      }
    }
  }
  .empty{
    display: flex;
    flex-direction: column;
    width: 100%;
    height: 100vh;
    .emptyBtn{
      width: 80%;
      margin: 0px auto;
      margin-top: 25vh;

      .emptyBtn_text{
        letter-spacing:5px;
      }
    }
  }
}
</style>